import { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import InfoTooltip from './InfoTooltip'

interface KpiCardProps {
  title: string
  value: string | number
  subtitle?: string
  detail?: string
  icon: LucideIcon
  color: 'emerald' | 'blue' | 'violet' | 'cyan' | 'amber' | 'rose'
  info?: ReactNode
}

const iconBgClasses = {
  emerald: 'bg-emerald-50 text-emerald-500',
  blue: 'bg-blue-50 text-blue-500',
  violet: 'bg-violet-50 text-violet-500',
  cyan: 'bg-cyan-50 text-cyan-500',
  amber: 'bg-amber-50 text-amber-500',
  rose: 'bg-rose-50 text-rose-500',
}

export default function KpiCard({ title, value, subtitle, detail, icon: Icon, color, info }: KpiCardProps) {
  return (
    <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-slate-500 flex items-center gap-1">
          {title}
          {info && <InfoTooltip>{info}</InfoTooltip>}
        </span>
        <div className={`w-6 h-6 rounded-md flex items-center justify-center ${iconBgClasses[color]}`}>
          <Icon className="w-3.5 h-3.5" />
        </div>
      </div>
      <div className="flex items-baseline justify-between gap-1">
        <div className="text-2xl font-bold text-slate-800 leading-none">
          {value}
          {subtitle && <span className="text-sm text-slate-400 font-normal ml-0.5">{subtitle}</span>}
        </div>
        {detail && <div className="text-[10px] text-slate-400 text-right leading-tight whitespace-pre-line">{detail}</div>}
      </div>
    </div>
  )
}
